import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n";

export const SEO = ({ title, description, path = "/" }) => {
    const { lang } = useLang();
    return (
        <Helmet>
            <html lang={lang} />
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={`https://girne1taksi.com${path}`} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={`https://girne1taksi.com${path}`} />
        </Helmet>
    );
};
